<template>
    <div>
        <h2>Angaben zur Reise</h2>
        <p style=text-align:left>Ich interessiere mich für*</p>
        
        <el-row style=color:black;font-weight:bold><el-radio label="Gruppenreise/Studienreise (Erwachsene)" v-model="radio"></el-radio></el-row>
        <el-row style=color:black;font-weight:bold><el-radio label="Klassenfahrten/Reisen für Jugendgruppen" v-model="radio"></el-radio></el-row>
        <el-row style=color:black;font-weight:bold><el-radio label="Transfer" v-model="radio"></el-radio></el-row>

        <p style=text-align:left>Gewünschtes Reiseziel</p>
       

<el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div>Land</div><el-select style="width:100%;" v-model="Land" placeholder="Bitte wählen"><el-option v-for="item in optionsLand" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div>PLZ/Ort</div><el-input v-model="PLZ_Ort" placeholder="PLZ/Ort"></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>
<p style=text-align:left>Gewünschter Reisetermin</p>

<el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div class="block"><div>Hinfahrt</div>
    <el-date-picker style="width:100%" v-model="Hinfahrt" placeholder="TT.MM.JJJJ" default-value="2010-10-01"> </el-date-picker></div></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div>Uhrzeit</div><el-input v-model="Uhrzeit" placeholder="08:00 Uhr"></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

<el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div class="block"><div>Rückfahrt</div>
    <el-date-picker style="width:100%" v-model="Rückfahrt" placeholder="TT.MM.JJJJ" default-value="2010-10-01"> </el-date-picker></div></el-col>
  <el-col :xs="23" :sm="11" :md="11" :lg="11" :xl="11"><div>Uhrzeit</div><el-input v-model="Uhrzeit2" placeholder="08:00 Uhr"></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

<el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"><div>Personenzahl</div><el-input v-model="Personenzahl" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

<el-row :gutter="10">
   <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"><div>Reiseverlauf</div><el-input type="textarea" v-model="Reiseverlauf" :rows="4" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

<el-row :gutter="10">
   <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="22" :md="22" :lg="22" :xl="22"><div>Sonstiges</div><el-input type="textarea" v-model="Sonstiges" :rows="4" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

<h2>Angaben zur Reise</h2>
 <p style="text-align:left">Angaben zur Person</p>

 <el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Anrede</div><el-input v-model="Anrede" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Titel</div><el-input v-model="Titel" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Name der Institution / Verein / Schule</div><el-input v-model="Name_Institution" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

 <el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Vorname*</div><el-input v-model="Vorname" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Name*</div><el-input v-model="Name" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="2" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>E-Mail</div><el-input v-model="EMail" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

 <el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Straße*</div><el-input v-model="Straße" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Hausnr.*</div><el-input v-model="Hausnr" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Telefon</div><el-input v-model="Telefon" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>

 <el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>PLZ*</div><el-input v-model="PLZ" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="6" :lg="6" :xl="6"><div>Ort*</div><el-input v-model="Ort" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
  <el-col :xs="23" :sm="23" :md="4" :lg="3" :xl="6"><div>Fax</div><el-input v-model="Fax" placeholder=""></el-input></el-col>
  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><div></div></el-col>
</el-row>
<br>
<b>Wie sind Sie auf uns aufmerksam geworden?</b> <br>

<el-row :gutter="10">
    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
  <el-col :xs="23" :sm="14" :md="14" :lg="14" :xl="14"><el-select style="width:100%;" v-model="aufmerksam" placeholder="Bitte wählen"><el-option v-for="item in optionsaufmerksam" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-col>
</el-row> <br>

<el-row>
<!-- `checked` should be true or false -->
  <el-checkbox v-model="checkedDatenschutz" style="font-weight:bold"> </el-checkbox> Ja, ich habe die <a href="https://www.gessert-reisen.de/#/article/datenschutz">Datenschutzerklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage genutzt.
</el-row> <br>

<el-row>
<!-- `checked` should be true or false -->
  <el-checkbox v-model="checkedAGB" style="font-weight:bold"> </el-checkbox>Ja, ich habe die <a href="https://www.gessert-reisen.de/#/article/AGB-Mietbus">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese. </el-checkbox>
</el-row> <br>

  <el-button type="warning">Anfrage senden</el-button>
    </div>
</template>

<script>

export default {
    data() {
        return {
            text: '',
            form: {
                subject: "Busanmietung",
                Name: "",
                Straße: "",
                PLZ: "",
                Ort: "",
                Telefon: "",
                Email: "",
                Betreff: "",
                Nachricht: "",
                checkedAGB: false,
                checkedDatenschutz: false
            }
        }
    },
    mounted(){
        this.text = content.find(item => item.id == 13).text
    },
    methods: {
        onSubmit() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$alert(this.errors.all().join("<br>"), "Fehler", { dangerouslyUseHTMLString: true })
                    return
                }
                let formData = new FormData()
                for (const key in this.form) {
                    formData.append(key, this.form[key])
                }

                fetch("../forms/php/mail_action.php", { method: "POST", body: formData })
                    .then(res => res.text())
                    .then(jsonData => {
                        this.form = {};
                        this.$alert('Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.', "Mail versendet", { dangerouslyUseHTMLString: true })
                    })
                    .catch(error => {
                        this.$alert('Die E-Mail konnte leider nicht versendet werden.', "Fehler", { dangerouslyUseHTMLString: true })
                    return
                    })
            })
        }
    }
  }
</script>

<style>
.el-input,
.el-button {
    width: 100%;
}

textarea {
    resize: none;
}


</style>